import React from 'react'
import BackwardButton from './backwardButton'
import ForwardButton from './forwardButton'
import PlayPauseButton from './playPauseButton'
import { convertVideoSecondstoMintues } from '../playerHelper'
import PrevButton from './prevButton'
import NextButton from './nextButton'

const PlayMenu = (props) => {
  let {
    isPlaying,
    togglePlayPause,
    currentTime,
    duration,
    playerData,
    backwardClick,
    forwardClick,
    handlePrev,
    handleNext,
  } = props

  let playPauseData = playerData.control_bar.data.middle_control_buttons.play_pause
  let backwardData = playerData.control_bar.data.middle_control_buttons.backward_forward
  let prevNextData = playerData.control_bar.data.middle_control_buttons.prev_next
  let playTimeData = playerData.control_bar.data.middle_control_buttons.play_time

  return (
    <div
      style={{ fontFamily: playTimeData.font_style, color: playTimeData.text_color }}
      className={`flex items-center text-xs ${playTimeData.font_format}`}
    >
      {playTimeData.visible ? (
        <p style={{ marginRight: 'min(1.4vw , 26px)' }}>
          {convertVideoSecondstoMintues(currentTime)}
        </p>
      ) : null}

      {handlePrev && handleNext ? (
        <div
          style={{ marginRight: backwardData.visible ? 'min(1vw , 20px)' : '' }}
          onClick={handlePrev}
        >
          <PrevButton data={prevNextData} />
        </div>
      ) : null}

      <div>
        <BackwardButton data={backwardData} backwardClick={backwardClick} />
      </div>
      <div style={{ margin: '0 min(1.2vw , 20px)' }}>
        <PlayPauseButton
          isPlaying={isPlaying}
          togglePlayPause={togglePlayPause}
          data={playPauseData}
        />
      </div>
      <div>
        <ForwardButton data={backwardData} forwardClick={forwardClick} />
      </div>
      {handlePrev && handleNext ? (
        <div
          style={{ marginLeft: backwardData.visible ? 'min(1vw , 20px)' : '' }}
          onClick={handleNext}
        >
          <NextButton data={prevNextData} />
        </div>
      ) : null}

      {playTimeData.visible ? (
        <p style={{ marginLeft: 'min(1.4vw , 26px)' }}>{convertVideoSecondstoMintues(duration)}</p>
      ) : null}
    </div>
  )
}

export default PlayMenu
